import React, {useEffect, useState} from "react";
import PDF from "../icons/PDF";
import CircleChevron from "../icons/CircleChevron";
import Close from "../icons/Close";
import ChevronUp from "../icons/ChevronUp";
import SquarePlus from "../icons/SquarePlus";
import makeItinerary from "../utils/makeItinerary";
import moment from "moment";
import ItineraryFinderPopup from "./ItineraryFinderPopup";
import Listing from "./Listing";

const LOCAL_STORAGE = 'LOCAL_STORAGE';

const ItineraryPage = (props) => {

    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [init, setInit] = useState(false);
    const [itinerary, setItinerary] = useState();
    const [opened, setOpened] = useState([]);
    const [searchFor, setSearchFor] = useState(null);
    const [searchForTitle, setSearchForTitle] = useState(null);
    const [slotAddress, setSlotAddress] = useState([]);
    const now = new Date();

    const {
        configs
    } = props;


    useEffect(() => {
        if (itinerary) {
            window.localStorage.setItem(LOCAL_STORAGE, JSON.stringify(itinerary));
        } else if (!init) {
            const json = window.localStorage.getItem(LOCAL_STORAGE);
            if (json) {
                const o = JSON.parse(json);
                setItinerary(o);
                setStart(o.start);
                setEnd(o.end);
                setInit(true);
            } else {
                setInit(true);
            }
        }
    }, [itinerary])

    useEffect(() => {
        if (start && end && init) {
            setItinerary(makeItinerary(start, end, itinerary));
        }
    }, [start, end]);

    const isOpened = (index) => {
        return findOpenedIndex(index) >= 0;
    }

    const isSubOpened = (index, subIndex) => {
        const i = findOpenedIndex(index);
        return i >= 0 && opened[i].sub.indexOf(subIndex) >= 0;
    }

    const findOpenedIndex = (index) => {
        return opened.findIndex((entry) => {
            return entry.index === index;
        });
    }

    const openCloseDay = (index) => {
        const newOpened = [...opened];
        if (isOpened(index)) {
            newOpened.splice(findOpenedIndex(index), 1);
        } else {
            newOpened.push({
                index: index,
                sub: [0, 1, 2, 3]
            });
        }
        setOpened(newOpened);
    }

    const openCloseSub = (main, sub) => {
        const newOpened = [...opened];
        const i = findOpenedIndex(main);
        if (isSubOpened(main, sub)) {
            newOpened[i].sub.splice(newOpened[main].sub.indexOf(sub), 1);
        } else {
            newOpened[i].sub.push(sub);
        }
        setOpened(newOpened);
    }

    const onSearchClose = () => {
        setSearchFor(null)
    }

    const onListingAdd = (listing) => {
        const newItinerary = {...itinerary};
        const i = slotAddress[0];
        const j = slotAddress[1];
        const k = slotAddress[2];
        newItinerary.days[i].items[j].list[k].item = listing;
        setItinerary(newItinerary);
        setSearchFor(null);
        setSlotAddress([]);
    }

    const removeListing = (address) => {
        const newItinerary = {...itinerary};
        const i = address[0];
        const j = address[1];
        const k = address[2];
        newItinerary.days[i].items[j].list[k].item = null;
        setItinerary(newItinerary);
    }


    return <>
        <div className="container">
            <div className={`itn ${itinerary ? 'entries-open' : ''}`}>

                <div className="itn__intro">
                    <div className="itn__intro__left">
                        <h2>Select the dates of your visit</h2>
                        <p>
                            <strong>Please note.</strong> Our itinerary builder is meant as a guide to your stay.
                            Please check that any attraction, eatery or accommodation options are open and available
                            during your visit. Our itinerary builder is not a booking system, and some listings may
                            require a booking. Bookings, open hours and availability can be found on the listings page
                            or by searching Google.
                        </p>
                    </div>
                    <form
                        method={'post'}
                        target={'_blank'}
                        action={configs.pdf}
                        className="itn__intro__right">
                        <input
                            name={'json'}
                            value={JSON.stringify(itinerary)}
                            type={'hidden'}
                        />
                        <button
                            disabled={!itinerary}
                            className="btn btn--solid btn--solid--navy">
                            Download your Itinerary as a PDF
                            <PDF />
                        </button>
                    </form>
                </div>

                <div className="itn__dates">
                    <div className="itn__date">
                        <label>Date from:</label>
                        <div>
                            <input
                                type="date"
                                placeholder="Add date"
                                min={moment(now).format('YYYY-MM-DD')}
                                value={start}
                                onChange={(e) => {
                                    setStart(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                    <div className="itn__date">
                        <label>Date to:</label>
                        <div>
                            <input
                                type="date"
                                placeholder="Add date"
                                value={end}
                                min={start}
                                onChange={(e) => {
                                    setEnd(e.target.value)
                                }}/>
                        </div>
                    </div>
                </div>


            </div>
        </div>
        {itinerary && <>
            <div className="itn__entries">
                {itinerary.days.map((day, i) => {
                    return <div key={i} className="itn__entry">
                        <div className="container">
                            <div className="itn__entry__inner">
                                <div className="itn__entry__title">
                                    <h3 className="h2">{moment(day.date).format('dddd D MMM YYYY')}</h3>
                                    <button
                                        onClick={() => {
                                            openCloseDay(i);
                                        }}
                                    >
                                        <CircleChevron />
                                    </button>
                                </div>

                                {isOpened(i) && <>
                                    {day.items.map((col, j) => {
                                        return <div key={j} className="itn__entry__collection">
                                            <div className="itn__entry__title itn__entry__sub-title">
                                                <h4 className="h2">{col.title}</h4>
                                                <button
                                                    onClick={() => {
                                                        openCloseSub(i, j)
                                                    }}
                                                >
                                                    {isSubOpened(i, j) ? 'Hide' : 'Show'} <ChevronUp />
                                                </button>
                                            </div>
                                            {isSubOpened(i, j) && <>
                                                <div className="itn__entry__row">
                                                    {col.list.map((list, k) => {
                                                        return <div key={k} className="itn__entry__cell">
                                                            <p className="itn__entry__cell-title">
                                                                {list.title}
                                                            </p>
                                                            <div className="itn__entry__cell-content">
                                                                <div
                                                                    className={list.item ? 'itn__entry__cell-listing' : 'itn__entry__cell-add'}
                                                                    onClick={() => {
                                                                        if (!list.item) {
                                                                            setSlotAddress([i, j, k]);
                                                                            setSearchFor(col.type);
                                                                            setSearchForTitle(col.title);
                                                                        }
                                                                    }}
                                                                >
                                                                    {!!list.item && <Listing
                                                                        listing={list.item}
                                                                        urlBase={configs[col.type]}
                                                                        defaultBlank={true}
                                                                    />}
                                                                    {!list.item && <>
                                                                        <div className="itn__entry__cell-plus">
                                                                            <SquarePlus />
                                                                        </div>
                                                                        <button
                                                                            className="btn btn--solid btn--solid--white">
                                                                            Add activity
                                                                        </button>
                                                                    </>}
                                                                </div>
                                                            </div>
                                                            {!!list.item && <button
                                                                className="btn btn--solid--fawn itn__entry__remove"
                                                                onClick={() => {
                                                                    removeListing([i, j, k])
                                                                }}
                                                            >
                                                                <Close />
                                                                Remove
                                                            </button>}
                                                        </div>
                                                    })}
                                                </div>
                                            </>}
                                        </div>
                                    })}
                                </>}
                            </div>
                        </div>
                    </div>

                })}

            </div>
        </>}
        {!!searchFor && <ItineraryFinderPopup
            title={searchForTitle}
            type={searchFor}
            onClose={onSearchClose}
            onAdd={onListingAdd}
        />}
    </>


}

export default ItineraryPage;
